import type { ICockpitMdfGroup } from '../../../../lib'

import { COCKPIT_MDF_CHART_TOP_GROUPS_COUNT } from './config'

export type TMdfChartGroup = Pick<ICockpitMdfGroup, 'name' | 'requested' | 'paid'>

export const getCockpitMdfChartGroups = (
  groups: ICockpitMdfGroup[],
  otherGroupName: string
): TMdfChartGroup[] => {
  if (groups.length <= COCKPIT_MDF_CHART_TOP_GROUPS_COUNT) {
    return groups
  }

  const otherGroup = groups.slice(COCKPIT_MDF_CHART_TOP_GROUPS_COUNT).reduce<TMdfChartGroup>(
    (total, group) => ({
      ...total,
      requested: total.requested + group.requested,
      paid: total.paid + group.paid,
    }),
    { name: otherGroupName, requested: 0, paid: 0 }
  )

  return [...groups.slice(0, COCKPIT_MDF_CHART_TOP_GROUPS_COUNT), otherGroup]
}
